import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import "react-datetime/css/react-datetime.css";
import {
  Form,
  FormStyle,
  Formik,
  FormikControl,
  InputError,
  InputText,
  useTranslation
} from "@/imports-files/common/common";
import {
  Button,
  ComponentStyle,
} from "@/imports-files/components/confirmation-modal";
import {
  Yup,
  cancelInterviewByCandidate,
  cancelInterviewByClient,
  TRANSLATION,
} from "@/imports-files/pages/interviews/cronofy";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
export function CancelInterview({
  setBtnPopup,
  token,
  router,
  cancelledBy,
  setInitialData,
  setFlagForRender,
}) {
  const {t} = useTranslation()
  function showReasonSection() {
    document.querySelector(".confirmationSection").classList.add("dnone");
    document.querySelector(".reasonSection").classList.remove("dnone");
  }

  const initialValues = {
    reason: "",
  };

  const validationSchema = Yup.object({
    reason: Yup.string().required(TRANSLATION("errors:required")),
  });

  const confirmHint =
    cancelledBy == "client"
      ? t('modal:confirmation:interview:client_cancel')
      : t('modal:confirmation:interview:cancel')

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container}`}>
          <div className={ `${FormModalStyle.Modal__Container__Heading__Close}`}>
            <h1
              className={` ${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              {t('button:cancel_interview')}
            </h1>
            <div
              className={`${FormModalStyle.Modal__Container__CloseSection}`}
              onClick={() => setBtnPopup(false)}
            >
              <Close/>
            </div>
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
            <h3
              className={`${FormModalStyle.Modal__Container__ContentSection__Description}`}
            >
              {confirmHint}
            </h3>

            <div className={`${ComponentStyle.CancelInterview__Content} mt30`}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  if (cancelledBy == "client")
                    await cancelInterviewByClient(
                      values,
                      token,
                      setBtnPopup,
                      router,
                      setInitialData,
                      setFlagForRender
                    );
                  else
                    await cancelInterviewByCandidate(
                      values,
                      token,
                      router,
                      setBtnPopup,
                      setInitialData
                    );
                }}
              >
                {(formik) => (
                  <Form>
                    <div
                      className={`${FormModalStyle.Modal__Container__ContentSection__Block} ${PageStyle.Form__TableCol}`}
                    >
                      <label className={`${PageStyle.Form__FloatingLabel}`} style={InputText(formik, "reason")}>
                        <span className={`red-color`}>*</span>&nbsp;{t('label:reason_to_cancel_interview')}
                      </label>
                      <FormikControl
                        control="customtextarea"
                        type="text"
                        formik={formik}
                        className={`${PageStyle.Form__Textarea} ${PageStyle.Form__TextareaPlaceholder}`}
                        placeholder={t('placeholder:write_here')}
                        name={"reason"}
                        style={InputError(formik, "reason")}
                      />
                    </div>

                    <div
                      className={`${FormModalStyle.Modal__Container__ButtonSection}`}
                    >
                      <Button
                        buttonstyle={ComponentStyle.secondarybtnborder}
                        type="button"
                        onClick={() => setBtnPopup(false)}
                      >
                        {t('button:no_changed_my_mind')}
                      </Button>
                      <Button buttonstyle={PageStyle.primarybtn} type="submit">
                      {t('button:cancel_interview')}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
